export default {
  title: "Код участника",
  invitePlaceholder: "Введите код участника",
  tooltip:
    "Код участника открывает новые возможности Личного кабинета. Предоставляется после оформления договора на участие в выставке. <br /> Здесь Вы также можете внести код доступа для монтажной организации.",
  successInvite: "Вам предоставлен доступ к компании {companyName}",
  error: {
    notFound: "Код участника не найден",
    userMismatch: "Код участника принадлежит другому пользователю",
    server: "Серверная ошибка",
    userFromDifferentCompany: "Пользователь принадлежит другой компании",
    participantNotFound: "Участник не найден",
    participantCreationError: "Ошибка создания заявки",
    calendarElementCreationError:
      "Ошибка создания элемента календаря мероприятий",
    colorgNotFound: "Не найдена заявка коллективного организатора",
    companyNotFound: "Компания не найдена"
  }
};
